<template>
  <div style="padding:50px 0px;">
    <div>
      <section class="row"  :class="{'section-loading': isLoading}">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width:20%" class="text-center">保障項目編號</th>
              <th style="width:20%" class="text-center">保障項目說明</th>
              <th style="width:20%" class="text-center">保障項目歸類</th>
              <th style="width:20%" class="text-center">計算方法</th>
              <th style="width:10%" class="text-center">編輯</th>
              <th style="width:10%" class="text-center">刪除</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in categoryList" :key="`tradition-data-${i}`">
              <td>{{item.categoryNum}}</td>
              <td>{{item.categoryName}}</td>
              <td>{{item.categoryParent}}</td>
              <td>{{item.methodName}}</td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="doEdit(item)"
                  >
                編輯
                </button>
              </td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-default btn-sm"
                  @click="deleteItem(item)"
                  >
                刪除
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
    <Coverage-Kind-Add-Modal
      :open="coverageKindAddModalOpen"
      :categoryNameData="categoryNameData"
      :isEdit="true"
      @close="closeCoverageKindAddModal"
      @cancel="panelClose('coverageKindAddModalOpen')"
      />
  </div>
</template>

<script>
import CoverageKindAddModal from "./components/CoverageKindAddModal";
import { commonMixin } from "@/mixins/common";
import {
  queryCoverageCategoryMain,
  deleteCoverageCategoryMain,
} from "@/service";
export default {
  name: "CoverageKindKindList",
  mixins: [commonMixin],
  components: {
    CoverageKindAddModal,
  },
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categoryList: [],
      categoryNameData: {},
      coverageKindAddModalOpen: false,
      isLoading: false,
    };
  },
  watch: {
    reload(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.categoryList = [];
      this.isLoading = true;
      queryCoverageCategoryMain(this.$store.state.userInfo.id).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.categoryList = result.data.map((item) => {
              return {
                categoryId: item.coveragecategoryid,
                categoryNum: item.sequencenumber,
                categoryName: item.name,
                categoryParent: item.parent,
                methodName: item.methodname,
              };
            });
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    doEdit(data) {
      this.categoryNameData = data;
      this.panelOpen("coverageKindAddModalOpen");
    },
    deleteItem(data) {
      if (confirm("確認刪除此筆保障項目？")) {
        this.isLoading = true;
        deleteCoverageCategoryMain(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.init();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
          }
        );
      }
    },
    closeCoverageKindAddModal() {
      this.panelClose("coverageKindAddModalOpen");
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
